import { useEffect, useMemo } from "react";
import { FiRefreshCw, FiShield } from "react-icons/fi";
import { LuCircleHelp, LuClock3 } from "react-icons/lu";
import { RiBankLine } from "react-icons/ri";
import { useNavigate, useSearchParams } from "react-router-dom";
import EMIsAPI from "../../services/emi-api";
import { REACT_APP_RAMFINCORP_WEBSITE_URL } from "../../utils/environment";
import styles from "./PaymentPendingStatus.module.scss";

export default function PaymentPendingStatus() {

    const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const api = useMemo(() => new EMIsAPI(), []);

  const lms_id = searchParams.get("lms_id");
  useEffect(() => {
    let interval;
    let timeout;

    const checkStatus = async () => {
      try {
        const response = await api.fetchPaymentStatusAPI(
          lms_id
        );
        if (!response?.data?.inProgress) {
          clearInterval(interval);
          clearTimeout(timeout);

          navigate("/", { replace: true });
        }
      } catch (error) {
        clearInterval(interval);
        clearTimeout(timeout);

        navigate("/", { replace: true });
      }
    };

    checkStatus();

    interval = setInterval(checkStatus, 5000);

    timeout = setTimeout(() => {
      clearInterval(interval);
      navigate("/", { replace: true });
    }, 20 * 60 * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [api, lms_id, navigate]);

  return (
    <div className={styles.paymentPendingStatus}>
      <div className={styles.container}>
        <img
          src="/images/payment-pending.png"
          alt="Payment Pending"
          className={styles.pendingImage}
        />

        <h1 className={styles.title}>Payment is pending</h1>

        <p className={styles.description}>
          We are processing your payment and
          <br />
          fetching the status from your bank.
        </p>

     <div className={styles.statusCard}>
  <div className={styles.statusItem}>
    <div className={styles.icon}>
      <FiRefreshCw size={22} />
    </div>
    <div>
      <h4>Processing your payment</h4>
      <p>Please do not close this page</p>
    </div>
  </div>

  <div className={styles.statusItem}>
    <div className={styles.icon}>
      <RiBankLine size={22} />
    </div>
    <div>
      <h4>Fetching status from bank</h4>
      <p>This may take a few minutes</p>
    </div>
  </div>

  <div className={styles.statusItem}>
    <div className={styles.icon}>
      <LuClock3 size={22} />
    </div>
    <div>
      <h4>Status check in progress</h4>
      <p>We will update automatically</p>
    </div>
  </div>
</div>

       <div className={styles.infoBox}>
  <div className={styles.infoIcon}>
    <FiShield size={18} />
  </div>

  <p>
    We will redirect you to the repayment dashboard once we receive the
    payment status.
  </p>
</div>
       <div className={styles.support}>
  <span className={styles.helpText}>
    <LuCircleHelp size={16} />
    Need help?
  </span>

  <a
    href={`${REACT_APP_RAMFINCORP_WEBSITE_URL}/support`}
    target="_blank"
    rel="noopener noreferrer"
  >
    Contact Support
  </a>
</div>
      </div>
    </div>
  );
}